if (!customElements.get("content-with-subnav-nav")) {

    class ContentWithSubnavNav extends HTMLElement {
    constructor() {
        super();

        this.tabs = this.querySelectorAll(`.content-with-subnav__nav-items li a`);
        this.container = this.querySelector(`.content-with-subnav__nav-items`);
        this.skeletons = this.nextElementSibling.querySelectorAll(`.__skeleton-true`);
        this.prevArrow = this.querySelector(`.content-with-subnav__arrows.__prev`);
        this.nextArrow = this.querySelector(`.content-with-subnav__arrows.__next`);

        if (!this.tabs.length != 0 || !this.container || !this.prevArrow || !this.nextArrow) return;

        this.initialActive();
        this.initialArrows();
        this.analyzeExpiredItems();
        this.setupListeners();
    }

    hasScrollbar(element) {
        return element.scrollWidth > element.clientWidth;
    }

    createArrows() {
        this.prevArrow.classList.add('__show');
        this.nextArrow.classList.add('__show');
    }

    removeArrows() {
        this.prevArrow.classList.remove('__show');
        this.nextArrow.classList.remove('__show');
    }

    initialArrows() {
        if (this.hasScrollbar(this.container)) {
            this.createArrows();
        }
    }

    analyzeExpiredItems() {
        let today = new Date();

        this.skeletons.forEach((item) => {
            let startDate = item.dataset.startDate ? new Date(item.dataset.startDate) : today;
            let endDate = item.dataset.endDate ? new Date(item.dataset.endDate) : today;

            if (startDate <= today && endDate >= today) {
                item.classList.remove("__skeleton-true");
            } else {
                item.remove();
            }
        })
    }

    initialActive() {
        let hash = window.location.hash;
        let set = false;

        this.tabs.forEach((tab) => {
            if (tab.hash == hash) {
                tab.classList.add("__active");
                set = true;
            } else {
            tab.classList.remove("__active");
            }
        })

        set == false && this.tabs[0].classList.add("__active");
    }

    updateTab(tab) {
        tab.classList.add("__active");
        window.location.hash = tab.hash;
        this.container.scrollLeft = tab.offsetLeft;
    }

    setupListeners() {
        this.tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                this.tabs.forEach((tab) => {
                    tab.classList.remove("__active");
                })

                tab.classList.add("__active");
            })
        })

        this.nextArrow.addEventListener("click", () => {
            let found = false;
            this.tabs.forEach((tab, i) => {
                if (tab.classList.contains('__active') && found == false) {
                    found = true;
                    tab.classList.remove("__active");
                    
                    let newTab = this.tabs[i + 1];
                    if (i == (this.tabs.length - 1)) {
                        newTab = this.tabs[0];
                    }

                    this.updateTab(newTab);
                }
            })
        });

        this.prevArrow.addEventListener("click", () => {
            this.tabs.forEach((tab, i) => {
                if (tab.classList.contains('__active')) {
                    tab.classList.remove("__active");
                    
                    let newTab = this.tabs[i - 1];
                    if (i == 0) {
                        newTab = this.tabs[this.tabs.length - 1];
                    }

                    this.updateTab(newTab);
                }
            })
        });

        window.addEventListener('resize', (event) => {
            if (this.hasScrollbar(this.container)) {
                this.createArrows();
            } else {
                this.removeArrows();
            }
        }, true);

        window.addEventListener("hashchange", (event) => {
        this.initialActive();
        });

    }
    }

    customElements.define("content-with-subnav-nav", ContentWithSubnavNav);
}